import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { RootState } from "../../../redux/store";

import { PaginationFilterDto } from "../../../types/Pagination";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import { getSurveyImports } from "../api/surveyImportAPI";
import { SurveyImportPagination } from "../types";

export const useGetSurveyImports = () => {

    const selectedFilters = useSelector(
        (state: RootState) => state.filters.surveyLoads.selectedFilters
    );

    const pagination = useSelector(
        (state: RootState) => state.historical.surveyLoads
    );

    const paginationFilters: PaginationFilterDto = {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<
        SurveyImportPagination,
        ApiErrorResponse
    >({
        queryKey: [
            'getSurveyImports',
            selectedFilters,
            pagination
        ],

        queryFn: () => getSurveyImports(paginationFilters),

        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false
    });
};